export default class Constants {
  public static readonly BACKEND_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.sssZ';
  public static readonly FRONTEND_DATETIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
  public static readonly FRONTEND_DATE_FORMAT = 'DD/MM/YYYY';
  public static readonly STRING_SPLITTER = '||';
}
